import React from 'react';
import { useNavigate } from 'react-router-dom';
import success from '../../assets/images/success.png';
import { FaCheckCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { appLoginUrl } from '../../Global';

const RegistrationSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="vendor-registration-container" style={{ padding: '2rem' }}>
      <div className="registration-page" style={{ textAlign: 'center' }}>
        <h4 className="mt-3 text-2xl font-bold text-gray-900">
          {t('registrationSuccess.title')}
        </h4>
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
          <img src={success} alt={t('registrationSuccess.successImageAlt')} />
        </div>

        <div className="mt-4 text-gray-600">
          <p className="text-sm">
            {t('registrationSuccess.message1')}
          </p>
          <p className="mt-2 text-sm">
            {t('registrationSuccess.message2')}
          </p>
          <p className="mt-2 text-sm">
            {t('registrationSuccess.message3')}
          </p>
        </div>
        <div className="mt-6">
          <button
            style={{ margin: "auto", backgroundColor: "#01c9c9", border: "none", color: "white" }}
            onClick={() => window.location.href = appLoginUrl}
            className="login-button"
          >
            {t('registrationSuccess.returnButton')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;